/**
 * The label for the subtotal row above an invoice discount. A custom discount
 * label (e.g. "Less AFSA levy") is not a discount in the client's eyes, so the
 * subtotal reads "before adjustment" rather than "before discount".
 */
export function grossSubtotalLabel(copy, customDiscount) {
    return copy(customDiscount ? 'invoice:totals.grossSubtotalBeforeAdjustment' : 'invoice:totals.grossSubtotal');
}
